import * as React from 'react'
import { ErrorMessage, Form, Field, FormikProps, withFormik } from 'formik'
import Link from 'next/link'
import * as Yup from 'yup'
import { ButtonVariant, OvalButton } from '@revelrygroup/components'

import { ErrorText } from '../elements/ErrorText'
import { Input } from '../elements/Input'
import { Label } from '../elements/Label'
import styles from './styles.module.scss'
import { routes } from '../../routes'

const validationSchema = Yup.object({
  email: Yup.string().email('Invalid').required('Required'),
  name: Yup.string().required('Required'),
})

export interface FormValues {
  email: string
  location: string
  name: string
}

interface Props {
  initialValues: FormValues
  onSubmit: (values: FormValues) => Promise<void>
}

const VisitorUserForm: React.FC<Props & FormikProps<FormValues>> = (props) => {
  return (
    <Form>
      <div>
        <Label htmlFor="name">Your Name</Label>

        <Field as={Input} name="name" type="text" />

        <ErrorMessage component={ErrorText} name="name" />
      </div>

      <div>
        <Label htmlFor="email">Email Address</Label>

        <Field as={Input} name="email" type="email" />

        <ErrorMessage component={ErrorText} name="email" />
      </div>

      <div>
        <Label htmlFor="location">Location (Optional)</Label>

        <Field as={Input} name="location" type="text" />

        <ErrorMessage component={ErrorText} name="location" />
      </div>

      <div>
        <p className={styles.small}>
          By continuing, you agree to the{' '}
          <Link href={routes.termsOfUse}>
            <a className={styles.link} rel="noopener" target="_blank">
              Terms of use
            </a>
          </Link>{' '}
          and{' '}
          <Link href={routes.privacyPolicy}>
            <a className={styles.link} rel="noopener" target="_blank">
              Privacy Policy
            </a>
          </Link>
          .
        </p>
      </div>

      <OvalButton
        as="button"
        className={styles.submitBtn}
        disabled={props.isSubmitting || !props.isValid}
        type="submit"
        variant={ButtonVariant.DEFAULT_DARK}
      >
        Submit
      </OvalButton>
    </Form>
  )
}

export default withFormik<Props, FormValues>({
  displayName: 'VisitorUserForm',
  handleSubmit: async (values, { props }) => await props.onSubmit(values),
  mapPropsToValues: (props) => props.initialValues,
  validateOnMount: true,
  validationSchema,
})(VisitorUserForm)
